// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","AppContainer":"App_AppContainer__SW6Q-","header":"App_header__PKNxv","LogoContainer":"App_LogoContainer__qZY8c","logo":"App_logo__KFImf"};